import { i as w, e as k, E as I, x as l, u as A, n as v, r as m } from "./abstract-base-CdeHT0x1.js";
import { e as S } from "./query-Brcoqn5X.js";
import { e as u } from "./class-map-Ckx5HLrM.js";
import { o as T } from "./unsafe-svg-BCSzTTw5.js";
import { B as P } from "./table-cell-eFwJxJGY.js";
import { C as B } from "./button-base-590OUKaH.js";
import { B as O } from "./events-CMiHMbSn.js";
import { S as L } from "./scale--i04D-nH.js";
import { c as z } from "./chevron-down-vHxwkNW3.js";
import { p as N, d as $ } from "./lifecycle-decorators-VlFt_asj.js";
import { a as c } from "./query-assigned-DiX8lRAH.js";
import { BeaconButton as V } from "../beacon-button/index.js";
var r = /* @__PURE__ */ ((g) => (g.ONE = "1", g.TWO = "2", g.THREE = "3", g))(r || {});
const M = `<svg slot="suffix" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M4 10L8 6L12 10" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
</svg>`, q = w`:root[beacon-tag-name=beacon-table-stub],:root [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub]{--table-stub-variable-unset: unset;--table-stub-space-zero-value: 0;--table-stub-category-icon-margin-block-start: 0;--table-stub-title-icon-margin-block-start: 0;--table-stub-space-margin-inline-start: var(--beacon-reference-space-3);--table-stub-space-margin-inline-end: var(--beacon-reference-space-3);--table-base-stub-space-padding-block: var(--beacon-reference-space-2);--table-stub-floating-space-padding-inline: var(--beacon-reference-space-2);--table-stub-category-space-margin-inline: var(--beacon-reference-space-1);--table-stub-category-icon-space-margin-block: 0}@media (width >= 640px){:root[beacon-tag-name=beacon-table-stub],:root [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub]{--table-stub-title-icon-margin-block-start: var(--beacon-reference-space-1);--table-stub-space-margin-inline-start: var(--beacon-reference-space-5);--table-base-stub-space-padding-block: var(--beacon-reference-space-3);--table-stub-floating-space-padding-inline: 6px;--table-stub-category-space-margin-inline: var(--beacon-reference-space-2)}}@media (width >= 960px){:root[beacon-tag-name=beacon-table-stub],:root [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub]{--table-stub-space-margin-inline-end: var(--beacon-reference-space-4);--table-base-stub-space-padding-block: var(--beacon-reference-space-4)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-table-stub],:root [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub]{--table-stub-category-icon-margin-block-start: var(--beacon-reference-space-0);--table-stub-floating-space-padding-inline: var(--beacon-reference-space-3);--table-stub-category-icon-space-margin-block: var(--beacon-reference-space-1)}}`, G = w`[beacon-tag-name=beacon-table-stub] [slot=action-zone-right]{margin:var(--table-override-stub-action-zone-right-space, 0)}[beacon-tag-name=beacon-table-stub] [slot=action-zone-left]{--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-9);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-9);margin-block-start:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__title-icon{margin-block-start:var(--table-stub-title-icon-margin-block-start);margin-inline-start:var(--beacon-reference-space-2);vertical-align:text-top}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__title-icon,[beacon-tag-name=beacon-table-stub] .beacon-table-stub__category-icon{block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-5);min-inline-size:fit-content}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__category{--category-text-margin-block-start: var(--beacon-reference-space-2);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200);margin-block-start:0}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__category-icon{margin-block:0;margin-block-start:var(--table-stub-category-icon-margin-block-start)}`, F = w`@charset "UTF-8";:host{--override-button-space-padding-tertiary: var(--beacon-reference-space-4);--override-button-font-size-mini: var(--beacon-reference-font-scale-1);--override-button-font-line-height-mini: 1.6;--override-button-color-text-tertiary-default: var(--beacon-system-color-text-link);--override-button-icon-space-margin: var(--beacon-reference-space-2);--content-grid-template: "value-prop" "standard";--content-grid-template-columns: initial;--value-prop-margin-inline-end: 0;--value-prop-margin-block-end: var(--beacon-reference-space-2);--action-zone-left-margin-block-start: var(--beacon-reference-space-3);--stub-content-margin-inline-start: var(--table-stub-space-margin-inline-start);--stub-content-margin-inline-end: var(--table-stub-space-margin-inline-end);color:var(--beacon-system-color-text-standard);inline-size:inherit;word-break:initial}:host([value-prop-left]){--content-grid-template-columns: auto 1fr;--content-grid-template: "value-prop standard";--value-prop-margin-inline-end: var(--beacon-reference-space-3);--value-prop-margin-block-end: 0}p{margin:0}.has-cell-padding{padding-block:0;padding-inline:0}.title{display:flex;grid-area:title}.title-footnote,::slotted(sup){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}.title-text{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}.category{display:flex;grid-area:category}.title,.category{font-weight:var(--beacon-system-font-weight-bold)}.value-prop{grid-area:value-prop;margin-block-end:var(--value-prop-margin-block-end);margin-inline-end:var(--value-prop-margin-inline-end);padding:0}.content{display:grid;grid-template-areas:var(--content-grid-template);grid-template-columns:var(--content-grid-template-columns);inline-size:100%}.content .hide{display:none}.standard{display:grid;grid-template-areas:"category" "title" "attributes" "status" "description" "footnote"}.standard *:not(:last-child){margin-block-end:var(--beacon-reference-space-1)}.standard .title{margin-block-start:0}.standard>*,.standard .category+.title{margin-block-start:0}.standard .status{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);background-color:var(--beacon-system-color-background-2);border-radius:var(--beacon-system-radius-corner-standard);grid-area:status;inline-size:fit-content;margin-block:var(--beacon-reference-space-2) var(--beacon-reference-space-2);padding-block:var(--beacon-reference-space-1);padding-inline:var(--beacon-reference-space-3)}.standard .status+*{margin-block-start:0}.content-wrapper{display:flex;gap:var(--beacon-reference-space-3)}.stub{display:grid;margin-inline:0}.stub.level-2 .content{margin-inline-start:var(--table-override-stub-content-space-margin-inline-start, var(--beacon-reference-space-5))}.stub.level-2 .title-text{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300)}.stub.level-2 ::slotted([slot=title-icon]){--title-icon-margin-block-start: var(--table-stub-category-icon-space-margin-block)}.stub.level-3 .content{margin-inline-start:var(--table-override-stub-content-space-margin-inline-start, var(--beacon-reference-space-5))}.stub.level-3 .title-text{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}.dropdown{display:var(--table-override-stub-dropdown-display, initial);justify-self:end}.attributes{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);grid-area:attributes}.category-text{--category-text-margin-block-start: var(--beacon-reference-space-1);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200);margin-block-start:var(--category-text-margin-block-start)}.description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);grid-area:description;margin-block-start:var(--beacon-reference-space-3)}.footnote{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);grid-area:footnote}@media (prefers-reduced-motion){.floating-stub{display:none}}@media (prefers-reduced-motion: no-preference){.floating-stub{background:var(--beacon-system-color-background-2);color:var(--beacon-system-color-text-standard);display:grid;grid-template-areas:"category title";inline-size:max-content;inset-block-start:0;inset-inline-start:var(--table-stub-floating-override-inset-inline-start, 0);margin-block-start:calc(-1 * var(--table-base-stub-space-padding-block));margin-inline-start:var(--table-stub-floating-override-margin-inline-start, -500%);padding-block-start:var(--beacon-reference-space-2);padding-inline:var(--table-stub-floating-space-padding-inline);place-items:center;position:absolute;transform:translateY(-50%);transition:margin-inline-start 1s;z-index:2}.floating-stub .category:after{content:"·";margin-inline:var(--table-stub-category-space-margin-inline)}.floating-stub .category-text{margin:0}.floating-stub .category .category-text{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}.floating-stub .title{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200)}.floating-stub .category-icon{margin-block:var(--table-stub-category-icon-space-margin-block)}}.wrapper{position:relative}@media (width >= 1280px){.category-text{--category-text-margin-block-start: 0}}`;
var H = Object.defineProperty, K = Object.getOwnPropertyDescriptor, o = (g, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? K(e, t) : e, i = g.length - 1, b; i >= 0; i--)
    (b = g[i]) && (s = (n ? b(e, t, s) : b(s)) || s);
  return n && s && H(e, t, s), s;
};
const h = "beacon-table-stub", _ = "1px solid var(--beacon-system-color-border-0)", f = "0", W = "calc(var(--beacon-reference-space-3) + var(--table-row-space-padding))", d = "th", Y = "tr", y = "border-block-end", Z = "beacon-table", R = "display", U = "none", j = "padding-block-end", X = "--inset-divider-border", Q = "--inset-divider-padding-block-start", J = "table-row", D = "--inset-divider-margin-start", ee = "calc(var(--beacon-reference-space-3) + var(--beacon-reference-space-5) + var(--table-stub-space-margin-inline-start))", te = "calc(var(--beacon-reference-space-3) + var(--beacon-reference-space-5) + var(--table-stub-space-margin-inline-start))", x = "--inset-divider-margin-end", ae = "13px", C = "BEACON-CHECKBOX", oe = "--action-zone-left-margin-block-start", ne = "checkbox", se = 'input[type="checkbox"]', re = "calc(var(--beacon-reference-space-3) + var(--table-stub-space-margin-inline-start))", ie = "calc(var(--beacon-reference-space-3) + var(--table-stub-space-margin-inline-end))";
var p;
const a = (p = class extends P {
  constructor() {
    super(...arguments), this.beaconTagName = h, this.nextStub = null, this.level = r.ONE, this.valuePropLeft = !1, this.withDropdown = !1, this.highlighted = !1, this.showDropdown = !1, this.hasCategory = !1, this.hasStatus = !1, this.hasValueProp = !1, this.hasDescription = !1, this.hasFootnote = !1, this.hasAttributeList = !1;
  }
  static get styles() {
    return [super.styles, F];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, G, q];
  }
  onBeaconRenderActionZone() {
  }
  /**
   * Used when the current instance is a level 2 stub
   * Triggers the visibility of possible level 3 children
   * @param {boolean} show - Boolean parameter that shows children on true
   */
  triggerChildren(e) {
    var n, s, i, b;
    let t = this.next;
    if (e) {
      for (; t; )
        t == null || t.showRow(), t = t.next;
      (s = (n = this.parentTableRow) == null ? void 0 : n.querySelector(d)) == null || s.style.setProperty(y, f);
    } else {
      for (; t; )
        t == null || t.hideRow(), t = t.next;
      (b = (i = this.parentTableRow) == null ? void 0 : i.querySelector(d)) == null || b.style.setProperty(y, _);
    }
  }
  /**
   * Used to trigger the state of the dropdown and visibility of level 3 children in a level 2 stub instance
   */
  handleClick() {
    this.showDropdown = !this.showDropdown, this.triggerChildren(this.showDropdown);
  }
  /**
   * Use to receive a reference to the next table stub in multi-level context
   *
   * @return {BeaconTableStub} contains a level 2 or level 3 stub
   */
  get next() {
    return this.nextStub;
  }
  /**
   * sets the parentTableRow class variable
   * Searches up the DOM tree to look for the first instance of a table `<tr>` element
   */
  setParentTableRow() {
    const e = this.closest(Y);
    e && (this.parentTableRow = e);
  }
  /**
   * sets the nextStub class variable
   * Searches for the current stub sibling to maintain a linked-list between level 2 and level 3 stubs
   */
  setNextStub(e = null) {
    var n, s;
    if (e) {
      this.nextStub = e;
      return;
    }
    const t = (s = (n = this.parentTableRow) == null ? void 0 : n.nextElementSibling) == null ? void 0 : s.querySelector(
      h
    );
    this.level !== r.ONE && (this.level === r.TWO && (t == null ? void 0 : t.level) !== r.THREE || this.level === r.THREE && (t == null ? void 0 : t.level) !== r.THREE || (this.nextStub = t));
  }
  setParentTableRowAndSetNextStub() {
    this.setParentTableRow(), this.setNextStub();
  }
  /**
   * Hides parent table row by setting display to none
   */
  hideRow() {
    var e;
    (e = this.parentTableRow) == null || e.style.setProperty(R, U);
  }
  /**
   * Shows parent table row by setting display to default table-row
   */
  showRow() {
    var e;
    (e = this.parentTableRow) == null || e.style.setProperty(R, J);
  }
  /**
   * Sets the hasMultiLevel property of parent beacon-table component to trigger vertical divider styles
   * in multi-level stub context
   */
  setMultiLevelTableProp() {
    const e = this.closest(
      Z
    );
    e && e._setMultiLevel(!0);
  }
  /**
   * addInsetRowBorders() removes the default full width borders of table header elements and instead adds
   * inset borders in multi-level stub context
   */
  addInsetRowBorders() {
    var t;
    const e = (t = this.parentTableRow) == null ? void 0 : t.querySelector(d);
    e && (e.style.setProperty(y, f), e.style.setProperty(j, f), e.style.setProperty(X, _), e.style.setProperty(
      Q,
      W
    ));
  }
  /**
   * Clones passed in childEl and inserts it before the first child of parentEl
   * @param  {HTMLElement} parentEl: Element that will hold childEl
   * @param  {Array<HTMLElement>} childEl: Element to be cloned and prepended to parentEl
   * @returns void
   */
  static cloneAndPrepend(e, t) {
    if (e && (t != null && t.length)) {
      const n = t.find((s) => s);
      if (n) {
        const s = n.cloneNode(!0);
        e.prepend(s);
      }
    }
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-render-action-zone - emits when the action zone is rendered inside a table
   */
  emitRenderActionZone() {
    k(
      this,
      O.RENDER_ACTION_ZONE,
      void 0,
      this.onBeaconRenderActionZone
    );
  }
  /**
   * change action-zone-left slot padding if it contains a checkbox
   */
  handleActionZone() {
    if (this.actionZoneLeft && this.actionZoneLeft.length) {
      this.emitRenderActionZone();
      const e = this.actionZoneLeft.find((s) => s), t = (e == null ? void 0 : e.getAttribute("type")) === ne || (e == null ? void 0 : e.tagName) === C, n = (e == null ? void 0 : e.querySelector(se)) || (e == null ? void 0 : e.querySelector(C));
      (t || n) && this.style.setProperty(
        oe,
        ae
      );
    }
  }
  /**
   * Sets stub styles based on level and trailing nextStubs
   */
  setStubStyles() {
    var t;
    const e = (t = this.parentTableRow) == null ? void 0 : t.querySelector(d);
    e && (this == null ? void 0 : this.level) === r.TWO && this != null && this.showDropdown && (e == null || e.style.setProperty(
      y,
      f
    )), this.level === r.TWO && this.setLevelOneInsetBorder();
  }
  /**
   * Sets inset borders for sibling level 1 stub if current instance is a level 2 stub
   */
  setLevelOneInsetBorder() {
    var t, n, s, i, b, E;
    const e = (n = (t = this.parentTableRow) == null ? void 0 : t.previousElementSibling) == null ? void 0 : n.querySelector(
      h
    );
    e == null || e.addInsetRowBorders(), (i = (s = e == null ? void 0 : e.parentTableRow) == null ? void 0 : s.querySelector(d)) == null || i.style.setProperty(
      D,
      re
    ), (E = (b = e == null ? void 0 : e.parentTableRow) == null ? void 0 : b.querySelector(d)) == null || E.style.setProperty(
      x,
      ie
    );
  }
  /**
   * Styles set when current instance is a level 3 stub
   */
  levelThreeStubStyles() {
    var e, t, n, s, i;
    this.nextStub && ((e = this.nextStub) == null ? void 0 : e.level) === (this == null ? void 0 : this.level) && this.addInsetRowBorders(), (n = (t = this.parentTableRow) == null ? void 0 : t.querySelector(d)) == null || n.style.setProperty(
      D,
      ee
    ), (i = (s = this.parentTableRow) == null ? void 0 : s.querySelector(d)) == null || i.style.setProperty(
      x,
      te
    );
  }
  /**
   * Sets the previous stub's next if a new row is inserted into the table
   */
  updatePreviousNext() {
    var t, n;
    const e = (n = (t = this.parentTableRow) == null ? void 0 : t.previousElementSibling) == null ? void 0 : n.querySelector(
      h
    );
    e && e.setNextStub();
  }
  tearDownTableStub() {
    var e, t;
    if (this.level === r.THREE) {
      const n = (t = (e = this.parentTableRow) == null ? void 0 : e.previousElementSibling) == null ? void 0 : t.querySelector(
        h
      );
      n && n.setNextStub(this.nextStub);
    }
  }
  render() {
    return l`
      <div class="wrapper">
        <div class="floating-stub">
          <div class="title"></div>
        </div>
        <div class="stub level-${this.level}">
          <div class="content-wrapper">
            <slot
              name="action-zone-left"
              @slotchange="${this.handleActionZone}"></slot>
            <div class="content has-cell-padding" part="content">
              ${this.renderValueProp()}
              <div class="standard">
                ${this.renderCategory()}
                <div class="title">
                  <slot></slot>
                  <slot class="title-text" name="title"></slot>
                  <slot class="title-footnote" name="title-footnote"></slot>
                  <slot name="title-icon"></slot>
                </div>
                ${this.renderAttributes()} ${this.renderStatus()}
                ${this.renderDescription()} ${this.renderFootnote()}
              </div>
            </div>
            <slot name="action-zone-right"></slot>
          </div>
          ${this.withDropdown ? l`${A`<${this.getScopedTag("beacon-button")}
          class="dropdown"
          @beacon-event-click="${this.handleClick}"
          variant=${B.TERTIARY}
          scale="${L.MINI}">
          ${this.showDropdown ? "Hide Items" : "Show Items"}
          ${this.showDropdown ? l`${T(M)}` : l`${T(z)}`}</${this.getScopedTag("beacon-button")}>`}` : I}
        </div>
      </div>
    `;
  }
  categorySlotChange() {
    var e;
    this.hasCategory = !!((e = this.slottedCategory) != null && e.length);
  }
  renderCategory() {
    const e = {
      category: !0,
      hide: !this.hasCategory
    };
    return l` <div class=${u(e)}>
      <slot name="category-icon"></slot>
      <slot name="category" @slotchange=${this.categorySlotChange}></slot>
    </div>`;
  }
  statusSlotChange() {
    var e;
    this.hasStatus = !!((e = this.slottedStatus) != null && e.length);
  }
  renderStatus() {
    const e = {
      status: !0,
      hide: !this.hasStatus
    };
    return l` <div class=${u(e)}>
      <slot name="status" @slotchange=${this.statusSlotChange}></slot>
    </div>`;
  }
  valuePropSlotChange() {
    var e;
    this.hasValueProp = !!((e = this.slottedValueProp) != null && e.length);
  }
  renderValueProp() {
    const e = {
      "value-prop": !0,
      hide: !this.hasValueProp
    };
    return l` <span
      class=${u(e)}
      @slotchange=${this.valuePropSlotChange}
      ><slot name="value-prop"></slot
    ></span>`;
  }
  descriptionSlotChange() {
    var e;
    this.hasDescription = !!((e = this.slottedDescription) != null && e.length);
  }
  renderDescription() {
    const e = {
      description: !0,
      hide: !this.hasDescription
    };
    return l` <div class=${u(e)}>
      <slot name="description" @slotchange=${this.descriptionSlotChange}></slot>
    </div>`;
  }
  footnoteSlotChange() {
    var e;
    this.hasFootnote = !!((e = this.slottedFootnote) != null && e.length);
  }
  renderFootnote() {
    const e = {
      footnote: !0,
      hide: !this.hasFootnote
    };
    return l` <div class=${u(e)}>
      <slot name="footnote" @slotchange=${this.footnoteSlotChange}></slot>
    </div>`;
  }
  attributesSlotChange() {
    var e;
    this.hasAttributeList = !!((e = this.slottedAttributes) != null && e.length);
  }
  renderAttributes() {
    const e = {
      attributes: !0,
      hide: !this.hasAttributeList
    };
    return l` <div class=${u(e)}>
      <slot name="attributes" @slotchange=${this.attributesSlotChange}></slot>
    </div>`;
  }
  postrenderTableStubSetup() {
    p.cloneAndPrepend(this.floatingTitle, this.titleText), p.cloneAndPrepend(this.floatingCategory, this.categoryIcon), (this == null ? void 0 : this.level) !== r.ONE && Promise.resolve(this.setNextStub()).then(() => {
      (this == null ? void 0 : this.level) === r.TWO && this.showDropdown && this.triggerChildren(this.showDropdown);
    }), this.level === r.TWO && this.setMultiLevelTableProp(), this.level === r.THREE && (this.levelThreeStubStyles(), this.updatePreviousNext(), this.hideRow());
  }
}, p.tagName = h, p.nestedComponents = [V], p);
o([
  v({ reflect: !0 })
], a.prototype, "level", 2);
o([
  v({ attribute: "value-prop-left", type: Boolean, reflect: !0 })
], a.prototype, "valuePropLeft", 2);
o([
  v({ attribute: "with-dropdown", type: Boolean, reflect: !0 })
], a.prototype, "withDropdown", 2);
o([
  v({ type: Boolean, reflect: !0 })
], a.prototype, "highlighted", 2);
o([
  v({ attribute: "show-dropdown", type: Boolean, reflect: !0 })
], a.prototype, "showDropdown", 2);
o([
  v({ attribute: "sort-value", reflect: !0 })
], a.prototype, "sortValue", 2);
o([
  c({ slot: "title-footnote" })
], a.prototype, "titleFootnote", 2);
o([
  c({ slot: "title-icon" })
], a.prototype, "titleIcon", 2);
o([
  c({ slot: "action-zone-left" })
], a.prototype, "actionZoneLeft", 2);
o([
  c({ slot: "category-icon" })
], a.prototype, "categoryIcon", 2);
o([
  c({ slot: "" })
], a.prototype, "titleText", 2);
o([
  S(".title-text")
], a.prototype, "titleElement", 2);
o([
  S(".floating-stub .category .category-icon")
], a.prototype, "floatingCategory", 2);
o([
  S(".floating-stub .title")
], a.prototype, "floatingTitle", 2);
o([
  m()
], a.prototype, "hasCategory", 2);
o([
  c({ flatten: !0, slot: "category" })
], a.prototype, "slottedCategory", 2);
o([
  m()
], a.prototype, "hasStatus", 2);
o([
  c({ flatten: !0, slot: "status" })
], a.prototype, "slottedStatus", 2);
o([
  m()
], a.prototype, "hasValueProp", 2);
o([
  c({ flatten: !0, slot: "value-prop" })
], a.prototype, "slottedValueProp", 2);
o([
  m()
], a.prototype, "hasDescription", 2);
o([
  c({ flatten: !0, slot: "description" })
], a.prototype, "slottedDescription", 2);
o([
  m()
], a.prototype, "hasFootnote", 2);
o([
  c({ flatten: !0, slot: "footnote" })
], a.prototype, "slottedFootnote", 2);
o([
  m()
], a.prototype, "hasAttributeList", 2);
o([
  c({ flatten: !0, slot: "attributes" })
], a.prototype, "slottedAttributes", 2);
o([
  N
], a.prototype, "setParentTableRowAndSetNextStub", 1);
o([
  $
], a.prototype, "tearDownTableStub", 1);
o([
  N
], a.prototype, "postrenderTableStubSetup", 1);
let we = a;
export {
  we as B,
  r as L
};
